import type { Attachment } from "@/api/content";
import { FilePreview } from "./FilePreview";

export function AttachmentList({ attachments }: { attachments: Attachment[] }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div className="attachments">
      {attachments.map((a) => (
        <FilePreview key={a.file_id} att={a} />
      ))}
    </div>
  );
}
